<script>
import { mapState, mapActions } from 'vuex';
import store from '../../../store';
import validatorMixin from '../../../mixins/validatorMixin';

export default {
  data() {
    return {
      fab: false,
      formValid: true,
      saveSuccess: false,
      snackbar: false,
      changed: false,
    };
  },
  mixins: [validatorMixin],
  computed: {
    ...mapState({
      active: state => state.areas.snowGuarantee.active,
      description: state => state.areas.snowGuarantee.description,
      title: state => state.areas.snowGuarantee.title,
      loading: state => state.areas.snowGuarantee.loading,
      error: state => state.areas.snowGuarantee.error,
      area: state => state.areas.area,
    }),
  },
  methods: {
    ...mapActions({
      setSnowGuarantee: 'areas/setSnowGuarantee',
      updateSnowGuarantee: 'areas/updateSnowGuarantee',
    }),
    onChange(payload) {
      this.setSnowGuarantee(payload);
      this.changed = true;
      this.$nextTick(() => {
        this.$refs.snowGuaranteeForm.validate();
      });
    },
    save() {
      if (this.$refs.snowGuaranteeForm.validate()) {
        this.updateSnowGuarantee({
          id: this.area.id,
          payload: {
            title: this.title && this.title.length ? this.title : null,
            active: this.active,
            description: this.description && this.description.length ? this.description : null,
          },
        }).then(() => {
          this.saveSuccess = true;
          this.snackbar = true;
          this.changed = false;
        }).catch(() => {
          this.saveSuccess = false;
          this.snackbar = true;
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('areas/fetchSnowGuarantee', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next();
      });
  },
  beforeRouteLeave(to, from, next) {
    return this.$changeDetect(this.changed, next);
  },
  mounted() {
    this.$refs.snowGuaranteeForm.validate();
  },
};
</script>
<template>
  <div class="ski-area-snow-guarantee">
    <v-form v-model="formValid" ref="snowGuaranteeForm">
      <div class="py-4 px-4">
        <div class="title mb-3">
          {{ $t('snowGuarantee.headings.active') }}
        </div>
        <div class="body-1 mb-3">
          {{ $t('snowGuarantee.labelDescriptions.active') }}
        </div>
        <v-checkbox
          :label="$t('snowGuarantee.labels.active')"
          :disabled="loading"
          :input-value="active"
          :rules="[rules.visibility.bind(this, { title: title, description: description })]"
          @change="onChange({ active: $event })"/>
      </div>
      <v-divider/>
      <div class="py-4 px-4">
        <div class="title mb-3">
          {{ $t('snowGuarantee.headings.title') }}
        </div>
        <div class="body-1 mb-3">
          {{ $t('snowGuarantee.labelDescriptions.title') }}
        </div>
        <v-text-field
          :label="$t('snowGuarantee.labels.title')"
          :disabled="loading"
          :value="title"
          :rules="[rules.title]"
          @input="onChange({ title: $event })"/>
      </div>
      <v-divider/>
      <div class="py-4 px-4">
        <div class="title mb-3">
          {{ $t('snowGuarantee.headings.description') }}
        </div>
        <div class="body-1 mb-3">
          {{ $t('snowGuarantee.labelDescriptions.description') }}
        </div>
        <tw-wysiwyg
          :placeholder="$t('snowGuarantee.labels.description')"
          :value="description"
          :disabled="loading"
          @change="onChange({ description: $event })"/>
      </div>
      <v-tooltip left :disabled="formValid">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            :loading="loading"
            @click="save"
            fixed
            bottom
            right
            color="primary"
            class="ski-area-snow-guarantee__button">
            {{ $t('save') }}
          </v-btn>
        </template>
        <span v-if="!formValid">{{ $t('formInvalid')}}</span>
      </v-tooltip>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="4000">
      <v-icon v-if="saveSuccess" class="mr-3 green--text">check_circle</v-icon>
      <v-icon v-else class="mr-3 red--text">warning</v-icon>
      {{ saveSuccess
      ? $t('snowGuarantee.snackbar.save.success')
      : $t('snowGuarantee.snackbar.save.error')
      }}
      <v-btn
        color="white"
        flat
        @click="snackbar = false">
        {{ $t('snowGuarantee.snackbar.save.button') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<style lang="scss">
  .ski-area-snow-guarantee {
    &__button {
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ski/areas/SkiAreaSnowGuarantee.vue